import { UserId } from "@nimble/datamodel/types/userId";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { getJobAlertsQueryKey } from "@/hooks/data/use-job-alerts";
import {
  editJobAlerts,
  EditJobAlertsJson,
} from "@/lib/api-clients/candidate-api-client";

export const useJobAlertsMutation = (userId: UserId) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (json: EditJobAlertsJson) => editJobAlerts(userId, json),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: getJobAlertsQueryKey(userId),
      }),
  });
};
